
import { defineComponent } from "vue";

export default defineComponent({
  name: "kn-menu-tiered",
  props: ["items"],
  emits: ["link", "over", "leave"],
  methods: {
    itemClick(e, item) {
      if (item) e.item = item;
      this.$emit("link", e);
    },
    emitOver() {
      this.$emit("over");
    },
    emitLeave() {
      this.$emit("leave");
    },
  },
});
